import { useMsal } from "@azure/msal-react";
import { useAuth } from "../../contexts/AuthContext";
import { isAuthEnabled, loginRequest } from "../../authConfig";
import { ProfileButton } from "../ProfileButton";
import styles from "./LoginButton.module.css";

export const LoginButton = () => {
    const { instance } = useMsal();
    const { user, loading, isAuthenticated, error } = useAuth();

    // If auth is disabled, show dev mode indicator
    if (!isAuthEnabled) {
        return (
            <div className={styles.userButton}>
                <span style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>Dev Mode</span>
            </div>
        );
    }

    const handleLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin
        });
    };

    if (loading) {
        return (
            <div className={styles.userButton}>
                <div
                    style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #93c5fd",
                        borderTopColor: "transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite"
                    }}
                />
            </div>
        );
    }

    // Authenticated at IdP level but backend auth profile unavailable
    if (isAuthenticated && !user && error) {
        return (
            <div className={styles.userButton}>
                <span style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>Backend Unreachable</span>
            </div>
        );
    }

    // Not authenticated — show sign-in button
    if (!isAuthenticated || !user) {
        return (
            <div className={styles.userButton}>
                <button
                    onClick={handleLogin}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.5rem",
                        padding: "0.6rem 1.2rem",
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        color: "#ffffff",
                        background: "linear-gradient(135deg, #0078d4 0%, #106ebe 100%)",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0, 120, 212, 0.3)",
                        transition: "all 0.2s ease"
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.background = "linear-gradient(135deg, #106ebe 0%, #005a9e 100%)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 120, 212, 0.4)";
                        e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.background = "linear-gradient(135deg, #0078d4 0%, #106ebe 100%)";
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 120, 212, 0.3)";
                        e.currentTarget.style.transform = "translateY(0)";
                    }}
                >
                    <svg width="21" height="21" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                        <path d="M0 0h11v11H0V0z" fill="#f25022" />
                        <path d="M12 0h11v11H12V0z" fill="#7fba00" />
                        <path d="M0 12h11v11H0V12z" fill="#00a4ef" />
                        <path d="M12 12h11v11H12V12z" fill="#ffb900" />
                    </svg>
                    <span>Sign in with Microsoft</span>
                </button>
            </div>
        );
    }

    return (
        <ProfileButton
            profile={{
                displayName: user.display_name,
                email: user.email,
                roles: user.roles
            }}
            buildId={(globalThis as any).APP_BUILD_ID || "dev"}
            onLogout={handleLogout}
            showPlatformLinks
        />
    );
};
